import axios from 'axios';
import miscFunctions from '../helpers/misc-functions';
import serviceUtil from './serviceUtil';

const DEFAULT_TIMEOUT = 20000;

function getInventory(inventoryId, options) {
  let request =  process.env.REACT_APP_API + '/inventories/' + inventoryId + '?current_company=' + localStorage.current_company_id;

  return axios({
    method: 'get',
    url: request,
    timeout: DEFAULT_TIMEOUT,
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'Authorization': 'Token token=' + localStorage.token,
    },
  }) 
  .then(response => {
    if (response.data.data) {
      let record = miscFunctions.mapApiJson(response.data);
      return record;
    }
  })
  .catch(error => {
    return serviceUtil.resultForError(error);
  });
}

export default {
  getInventory,
};



// WEBPACK FOOTER //
// ./src/services/inventoryService.js